import { action, makeObservable } from 'mobx';
import { post, get, getPage } from 'stores/_services/dataService';
export default class SearchStore {
    constructor() {
        makeObservable(this, {
            search: action
        });
    }
    async search(scanType: string, startDate: Date, endDate: Date, searchText?: string): Promise<void> {
        const { data } = await post('searchRequests', {
            query: {
                scanType: 'process',
                startDate: '2022-10-01T00:00',
                endDate: '2023-02-07T00:00'
            }
        });

        return data.id;
    }
    async searchById(Id: string): Promise<void> {
        const { data } = await get(`searchRequests/${Id}`);
        return data;
    }

    async fetchSearchResults(Id: string): Promise<void> {
        const options = {
            filter: {
                limit: 100,
                skip: 0,
                where: {
                    searchRequestId: Id
                }
            },
            includeFields: ['id', 'searchRequestId', 'data']
        };

        const { data } = await getPage('searchResults', options);
        return data;
    }
}
